import React, { useCallback, useState } from "react";
import Paper from "@mui/material/Paper";
import {useQueryPharmacies} from "../../queries/pharmacy/hooks/useQueryPharmacies";
import { PHARMACIES_LIST_ORDER_BY } from "../../queries/pharmacy/pharmacyTypeDefs";
import {Box, CircularProgress, TextField, Typography, debounce} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PharmacyListItem from "./PharmacyListItem";
import moment from "moment";
import { useQueryActivePharmacyVacations } from "../../queries/pharmacy/hooks/useQueryActivePharmacyVacations";

const Pharmacies:React.FunctionComponent = () => {
  const [searchInput, setSearchInput] = useState('');
  const [queryLoading, setQueryLoading] = useState(false);
  const {data, loading, refetch} = useQueryPharmacies({
    fetchPolicy: 'no-cache',
    variables: { orderBy: PHARMACIES_LIST_ORDER_BY },
  });
  const { data: vacationData } = useQueryActivePharmacyVacations({
    fetchPolicy: 'no-cache',
  });

  const createData = ( id: number, name: string, user: string, email: string, created: string, phone: string, status: any, vacationDates: string ) => {
    return { id, name, user, email, created, phone, status, vacationDates };
  }

  const getRows = () => {
    const vacationMap = new Map<number, string>();
    (vacationData?.activePharmacyVacations || []).forEach((item: any) => {
      vacationMap.set(
        item.pharmacyId,
        `${moment(item.vacationStartAt).format('MM/DD/YYYY')} - ${moment(item.vacationEndAt).format('MM/DD/YYYY')}`,
      );
    });

    return data.findManyPharmacy.map((pharmacy: any) => {
      const username = `${pharmacy.PharmacyUsers[0]?.User?.firstName} ${pharmacy.PharmacyUsers[0]?.User?.lastName}`
      return createData(
        pharmacy.id,
        pharmacy.legalName,
        username,
        pharmacy.email,
        pharmacy.createdAt,
        pharmacy.phone,
        pharmacy.PharmacyStatus,
        vacationMap.get(pharmacy.id) || '',
      );
    });
  }
  
  const search = useCallback(debounce(async (value: string) => {
    setQueryLoading(true);

    let andQuery: any = {};

    if (value) {
      andQuery = { legalName: { contains: value, mode: 'insensitive' } }
    }

    await refetch({
      where: andQuery,
      orderBy: PHARMACIES_LIST_ORDER_BY,
    });

    setQueryLoading(false);
  }, 1000), []);

  const handleSearch = (value: string) => {
    setSearchInput(value);
    search(value);
  }

  if (loading) {
    return <CircularProgress sx={{position: 'absolute', left: 'calc(150px + 50%)', top: '50%'}} color="inherit" />
  }

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', pb: 3 }}>
        <Typography component="h4" variant="h6">Pharmacies</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', pb: 3 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <TextField
            type="text"
            placeholder="Search by Legal name..."
            value={searchInput}
            onChange={(event: any) => handleSearch(event.target.value)}
            fullWidth
            sx={{ minHeight: '30px', minWidth:'300px' }}
            size='small'
          />
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{backgroundColor: '#ededed'}}>
            <TableRow>
              <TableCell>Legal name</TableCell>            
              <TableCell align="left">Email</TableCell>
              <TableCell align="left">Created</TableCell>
              <TableCell align="left">Phone</TableCell>
              <TableCell align="left">Created by</TableCell>
              <TableCell align="left">Vacation</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { 
              getRows().map((row: any) => (
                <React.Fragment key={row.id}>
                  <PharmacyListItem row={row} />
                </React.Fragment>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
      {queryLoading && <CircularProgress sx={{position: 'absolute', left: 'calc(150px + 50%)', top: '50%'}} color="inherit" />}
    </Paper>
  );
}

export default Pharmacies;